import lightTheme, { darkTheme, Theme } from '@ff/ui/styles/theme';
import { ENABLE_NEW_MENUBAR } from 'client/settings';

const THEME_PRIMARY_COLOR = ENABLE_NEW_MENUBAR ? '#171A20' : 'rgb(127,42,0)';
const BUTTON_ACTIVE_COLOR = ENABLE_NEW_MENUBAR ? '#171A20' : 'rgb(127,42,0)';
const BUTTON_DISABLED_COLOR = 'rgba(23, 26, 32, 0.3)';
const BUTTON_BORDER_RADIUS = ENABLE_NEW_MENUBAR ? '4px' : '0px';

const buttonStyles = {
  color: 'white',
  backgroundColor: THEME_PRIMARY_COLOR,
  borderColor: THEME_PRIMARY_COLOR,
  borderRadius: BUTTON_BORDER_RADIUS,
  cursor: 'pointer',

  ':disabled': {
    color: 'white',
    backgroundColor: BUTTON_DISABLED_COLOR,
    borderColor: BUTTON_DISABLED_COLOR,
  },

  ':hover:disabled': {
    color: 'white',
    backgroundColor: BUTTON_DISABLED_COLOR,
    borderColor: BUTTON_DISABLED_COLOR,
  },

  ':hover': {
    color: 'white',
    backgroundColor: THEME_PRIMARY_COLOR,
    borderColor: THEME_PRIMARY_COLOR,
  },
  ':active': {
    color: 'white',
    backgroundColor: BUTTON_ACTIVE_COLOR,
    borderColor: BUTTON_ACTIVE_COLOR,
  },
};

const getCustomizedTheme = (theme: Theme): Theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: THEME_PRIMARY_COLOR,
  },
  buttons: {
    ...theme.buttons,
    primary: {
      ...theme.buttons.primary,
      ...buttonStyles,
    },
    outlinePrimary: {
      ...theme.buttons.outlinePrimary,
      ...buttonStyles,
    },
    dark: {
      ...theme.buttons.dark,
      borderRadius: '4px',
    }
  },
});

const getCustomizedDarkTheme = (theme: Theme): Partial<Theme> => {
  const cTheme = getCustomizedTheme(theme);

  return {
    ...cTheme,
    colors: {
      ...cTheme.colors,
      bg01: 'black',
    }
  }
};

// Currently we use the same customized button style for dark and light themes both in configurator v3.
export const customizedLightTheme = getCustomizedTheme(lightTheme);
export const customizedDarkTheme = getCustomizedDarkTheme(darkTheme);

export default customizedLightTheme;

